"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var logistics = _interopRequireWildcard(require("@/api/logistics"));
var _elementUi = require("element-ui");
var _validate = require("@/utils/validate");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var defaultRole = {
  name: '',
  type: 1,
  appoint: 0,
  sort: 0,
  region: [{
    first: 1,
    firstPrice: 0,
    renewal: 0,
    renewalPrice: 0,
    city_ids: [],
    cityId: 0
  }],
  undelivery: 0,
  free: [],
  undelives: {}
};
var kg = '重量（kg）';
var m = '体积（m³）';
var statusMap = [{
  title: '首件',
  title2: '续件',
  title3: '包邮件数'
}, {
  title: "\u9996\u4EF6".concat(kg),
  title2: "\u7EED\u4EF6".concat(kg),
  title3: "\u5305\u90AE".concat(kg)
}, {
  title: "\u9996\u4EF6".concat(m),
  title2: "\u7EED\u4EF6".concat(m),
  title3: "\u5305\u90AE".concat(m)
}];
var _default = exports.default = {
  name: 'CreatTemplates',
  components: {},
  data: function data() {
    return {
      loading: false,
      rules: {
        name: [{
          required: true,
          message: '请输入模板名称',
          trigger: 'blur'
        }],
        free: [{
          type: 'array',
          required: true,
          message: '请至少添加一个区域',
          trigger: 'change'
        }],
        appoint: [{
          required: true,
          message: '请选择包邮方式',
          trigger: 'change'
        }],
        undelivery: [{
          required: true,
          message: '请选择是否指定区域不配送',
          trigger: 'change'
        }],
        type: [{
          required: true,
          message: '请选择计费方式',
          trigger: 'change'
        }],
        region: [{
          required: true,
          message: '请选择区域运费',
          trigger: 'change'
        }],
        city_ids: [{
          type: 'array',
          required: true,
          message: '请至少选择一个区域',
          trigger: 'change'
        }],
        first: [{
          required: true,
          message: '请输入',
          trigger: 'blur'
        }],
        renewal: [{
          required: true,
          message: '请输入',
          trigger: 'blur'
        }],
        firstPrice: [{
          required: true,
          message: '请输入运费',
          trigger: 'blur'
        }],
        renewalPrice: [{
          required: true,
          message: '请输入续费',
          trigger: 'blur'
        }]
      },
      nodeKey: 'city_ids',
      props: {
        children: 'child',
        label: 'name',
        value: 'cityId',
        multiple: true
      },
      dialogVisible: false,
      ruleForm: Object.assign({}, defaultRole),
      listLoading: false,
      cityList: [],
      columns: {
        title: '首件',
        title2: '续件',
        title3: '包邮件数'
      },
      tempId: 0,
      regionNew: [{
        first: 1,
        firstPrice: 0,
        renewal: 0,
        renewalPrice: 0,
        city_ids: [],
        cityId: 0
      }],
      type: 0 // 0添加 1编辑
    };
  },
  mounted: function mounted() {
    this.listLoading = false;
    var cityList = JSON.parse(sessionStorage.getItem('cityList'));
    this.cityList = cityList;
  },
  methods: {
    changeAppoint: function changeAppoint() {
      this.listLoading = false;
      var region = _toConsumableArray(this.ruleForm.region);
    },
    changType: function changType(type) {
      this.type = type;
    },
    confirmEdit: function confirmEdit(row, index) {
      row.splice(index, 1);
    },
    popoverHide: function popoverHide() {},
    handleClose: function handleClose() {
      this.dialogVisible = false;
      this.ruleForm = {
        name: '',
        type: 1,
        appoint: 0,
        sort: 0,
        region: [{
          first: 0,
          firstPrice: 0,
          renewal: 0,
          renewalPrice: 0,
          city_ids: [],
          cityId: 0
        }],
        undelivery: 0,
        free: [],
        undelives: {}
      };
      this.columns = Object.assign({}, statusMap[0]);
    },
    changeRegion: function changeRegion(value) {},
    changeRadio: function changeRadio(num) {
      this.columns = Object.assign({}, statusMap[num - 1]);
    },
    // 添加配送区域
    addRegion: function addRegion(region) {
      region.push(Object.assign({}, {
        first: 0,
        firstPrice: 0,
        renewal: 0,
        renewalPrice: 0,
        city_ids: [],
        cityId: ''
      }));
    },
    addFree: function addFree(Free) {
      Free.push(Object.assign({}, {
        number: 1,
        price: 1,
        city_ids: [],
        cityId: ''
      }));
    },
    /**
     * 详情
     * id 模板id
     * appoint true包邮 false不包邮
     **/
    getInfo: function getInfo(id, appoint) {
      var _this = this;
      this.tempId = id;
      var loadingInstance = _elementUi.Loading.service({
        fullscreen: true
      });
      logistics.templateDetailApi({
        id: id
      }).then(function (res) {
        _this.dialogVisible = true;
        var info = res;
        if (info.appoint === 0) info.type = 1;
        if (Number(info.appoint) > 0) {
          if (info.regionList && info.regionList.length > 0) {
            info.regionList.forEach(function (item, index) {
              item.title = JSON.parse(item.title);
              item.city_ids = item.title;
            });
          }
          if (info.freeList && info.freeList.length > 0) {
            info.freeList.forEach(function (item, index) {
              item.title = JSON.parse(item.title);
              item.city_ids = item.title;
            });
          }
        }
        _this.ruleForm = Object.assign(_this.ruleForm, {
          name: info.name,
          type: info.type,
          appoint: info.appoint,
          sort: info.sort,
          region: info.regionList || [],
          // 运费区域
          free: info.freeList || [] // 包邮区域
        });
        _this.regionNew = _toConsumableArray(_this.ruleForm.region);
        _this.columns = Object.assign({}, statusMap[_this.ruleForm.type - 1]);
        _this.$nextTick(function () {
          loadingInstance.close();
        });
      }).catch(function (res) {
        // console.integralLog(res)
        _this.$message.error(res.message);
        _this.$nextTick(function () {
          loadingInstance.close();
        });
      });
    },
    // 列表
    getCityList: function getCityList() {
      var _this2 = this;
      logistics.cityListTree().then(function (res) {
        sessionStorage.setItem('cityList', JSON.stringify(res));
        var cityList = JSON.parse(sessionStorage.getItem('cityList'));
        _this2.cityList = cityList;
      }).catch(function (res) {
        _this2.$message.error(res.message);
      });
    },
    change: function change(idBox) {
      idBox.map(function (item) {
        var ids = [];
        item.city_ids.map(function (j) {
          j.splice(0, 1);
          ids.push(j[0]);
        });
        item.city_ids = ids;
      });
      return idBox;
    },
    changeOne: function changeOne(idBox) {
      var city_ids = [];
      idBox.map(function (item) {
        item.splice(0, 1);
        city_ids.push(item[0]);
      });
      return city_ids;
    },
    onsubmit: (0, _validate.Debounce)(function (formName) {
      var _this3 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this3.loading = true;
          _this3.listLoading = true;
          var param = {
            appoint: _this3.ruleForm.appoint,
            name: _this3.ruleForm.name,
            sort: _this3.ruleForm.sort,
            type: _this3.ruleForm.type,
            // 配送区域及运费
            shippingTemplatesRegionRequestList: [],
            // 指定包邮设置
            shippingTemplatesFreeRequestList: []
          };
          _this3.ruleForm.region.forEach(function (el, index) {
            el.title = el.city_ids.length > 0 ? JSON.stringify(el.city_ids) : JSON.stringify([[0, 0]]);
            if (el.title === '[[0,0]]') {
              el.cityId = '0';
            } else {
              for (var i = 0; i < el.city_ids.length; i++) {
                el.city_ids[i].splice(0, 2);
              }
              el.cityId = el.city_ids.length > 0 ? el.city_ids.join(',') : '0';
            }
          });
          param.shippingTemplatesRegionRequestList = _this3.ruleForm.region;
          param.shippingTemplatesRegionRequestList.forEach(function (el, index) {
            _this3.$delete(el, 'city_ids');
          });
          _this3.ruleForm.free.forEach(function (el, index) {
            el.title = el.city_ids.length > 0 ? JSON.stringify(el.city_ids) : JSON.stringify([[0, 0]]);
            if (el.title === '[[0,0]]') {
              el.cityId = '0';
            } else {
              for (var i = 0; i < el.city_ids.length; i++) {
                el.city_ids[i].splice(0, 2);
              }
              el.cityId = el.city_ids.length > 0 ? el.city_ids.join(',') : '0';
            }
          });
          param.shippingTemplatesFreeRequestList = _this3.ruleForm.free;
          param.shippingTemplatesFreeRequestList.forEach(function (el, index) {
            _this3.$delete(el, 'city_ids');
          });
          if (_this3.ruleForm.appoint === 2) {
            _this3.ruleForm.region.map(function (item, index) {
              _this3.ruleForm.region[0].title = '[[0,0]]';
              _this3.ruleForm.region[0].cityId = '0';
            });
          }
          if (_this3.ruleForm.appoint === 0) {
            _this3.$delete(param, 'shippingTemplatesRegionRequestList');
            _this3.$delete(param, 'shippingTemplatesFreeRequestList');
            _this3.ruleForm.type = 0;
          }
          if (_this3.type === 0) {
            logistics.shippingSave(param).then(function (res) {
              _this3.$message.success('操作成功');
              _this3.$emit('getList');
              setTimeout(function () {
                _this3.handleClose();
              }, 800);
              _this3.loading = false;
            }).catch(function () {
              _this3.loading = false;
            });
          } else {
            logistics.shippingUpdate(param, {
              id: _this3.tempId
            }).then(function (res) {
              _this3.$message.success('操作成功');
              _this3.$emit('getList');
              setTimeout(function () {
                _this3.handleClose();
                _this3.loading = false;
                _this3.listLoading = false;
              }, 500);
            }).catch(function () {
              _this3.loading = false;
              _this3.listLoading = false;
            });
          }
        } else {
          return false;
        }
      });
    }),
    clear: function clear() {
      this.ruleForm.name = '';
      this.ruleForm.sort = 0;
    }
  }
};